import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { getCalendarSurfaceStore } from 'owa-calendar-surface-surface-store';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';

const DEFAULT_NUM_COLUMNS = 7;

export function getNumColumns() {
    const { dateRangeType, isInSplitView, userOptions } = getCalendarSurfaceStore();

    if (dateRangeType === DateRangeType.Month) {
        return DEFAULT_NUM_COLUMNS;
    }

    // VSO 84478: need to investigate why getSelectedCalendars() returns 0 on boot, patching here as we need a value other than 0 on boot
    const numSelectedCalendarColumns = isInSplitView
        ? Math.max(getSelectedCalendars().length, 1)
        : 1;
    if (dateRangeType === DateRangeType.Week) {
        return DEFAULT_NUM_COLUMNS * numSelectedCalendarColumns;
    }
    if (dateRangeType === DateRangeType.WorkWeek) {
        const numWorkDays = userOptions.workDays ? userOptions.workDays.length : 5;
        return numWorkDays * numSelectedCalendarColumns;
    }
    if (dateRangeType === DateRangeType.Day) {
        const numDaysInDayRange = getNumDaysInDayRange();
        return numDaysInDayRange * numSelectedCalendarColumns;
    }
    return DEFAULT_NUM_COLUMNS;
}
